/**
 * Good example of redirecting a front-end call to the services to perform work
 */
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContextService } from '../context.service';

@Component({
  selector: 'mutara-verify',
  templateUrl: './verify.component.html',
  standalone: false
})
export class VerifyComponent implements OnInit {
  successful: boolean = false;
  message: string | undefined;
  alertText: string | undefined;
  loading: boolean = true;

  constructor(private http: HttpClient,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private context: ContextService) {
  }

  ngOnInit(): void {
    this.context.setProgressIndeterminate(true);
    this.activeRoute.paramMap.subscribe((params) => {
      this.http.post('$service/reset-response', { key: params.get('id') })
        .subscribe({
          error: (err) => {
            this.message = err.message;
            this.loading = false;
            this.context.showProgress(false);
            this.alertText = 'Error state encountered. Redirecting to application...';
            setTimeout(() => {
              this.context.nextMessage('logout', true);
              this.router.navigate(['/apply']);
            }, 10000);
          },
          next: (result: any) => {
            // This will always return, the response will include any errors to be displayed
            this.successful = !result.error;
            this.loading = false;
            this.message = result.message ?? 'Invalid verification request';
            this.context.showProgress(false);
            let timeoutValue = (this.successful ? 5000 : 10000);
            this.alertText = `Redirecting to application. Please ${this.successful ? 'login with your new password' : ' attempt to reset your password or use your orginial password.'}`;
            setTimeout(() => {
              this.context.nextMessage('logout', true);
              this.router.navigate(['/apply']);
            }, timeoutValue);
          }
        });
    });
  }
}